import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Switch } from "@/components/ui/switch";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { btnPrimary, inputCls, PageHead, Panel } from "./ui";

export default function AdminUsers() {
  const { isOwner, user: me } = useAuth();
  const [users, setUsers] = useState([]);
  const [f, setF] = useState({ email: "", name: "", password: "", role: "collaboratore" });
  const load = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { if (isOwner) load(); }, [isOwner]);
  if (!isOwner) return <Navigate to="/admin" replace />;

  const create = async (e) => {
    e.preventDefault();
    try { await api.post("/admin/users", f); toast.success("Utente creato"); setF({ email: "", name: "", password: "", role: "collaboratore" }); load(); } catch (err) { toast.error(apiError(err)); }
  };
  const patch = async (id, body, msg = "Utente aggiornato") => {
    try { await api.patch(`/admin/users/${id}`, body); toast.success(msg); load(); } catch (err) { toast.error(apiError(err)); }
  };
  const resetPwd = (u) => { const p = window.prompt(`Nuova password per ${u.email} (min. 8 caratteri)`); if (p) patch(u.id, { password: p }, "Password aggiornata"); };

  return (
    <div data-testid="admin-users" className="max-w-4xl space-y-5">
      <PageHead title="Utenti amministrativi" subtitle="Titolare: accesso completo · Collaboratore: prodotti, foto e magazzino, senza pubblicazione e impostazioni" />
      <div className="space-y-2">
        {users.map((u) => (
          <div key={u.id} data-testid={`user-row-${u.email}`} className={`flex flex-wrap items-center gap-3 bg-white/60 border border-[#D5B98C]/50 p-3 ${u.active ? "" : "opacity-60"}`}>
            <div className="flex-1 min-w-[180px]"><div className="font-medium">{u.name}{u.id === me.id && " (tu)"}</div><div className="text-xs text-[#242321]/55">{u.email}</div></div>
            <select data-testid={`user-role-${u.email}`} disabled={u.id === me.id} value={u.role} onChange={(e) => patch(u.id, { role: e.target.value })} className={`${inputCls} w-auto`}>
              <option value="titolare">Titolare</option><option value="collaboratore">Collaboratore</option>
            </select>
            <label className="flex items-center gap-2 text-xs">Attivo<Switch data-testid={`user-active-${u.email}`} disabled={u.id === me.id} checked={u.active} onCheckedChange={(c) => patch(u.id, { active: c })} /></label>
            <button data-testid={`user-reset-${u.email}`} onClick={() => resetPwd(u)} className="text-xs underline">Password</button>
          </div>
        ))}
      </div>
      <Panel title="Nuovo utente">
        <form onSubmit={create} className="grid sm:grid-cols-2 gap-3">
          <input data-testid="new-user-name" required placeholder="Nome" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inputCls} />
          <input data-testid="new-user-email" required type="email" placeholder="Email" value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className={inputCls} />
          <input data-testid="new-user-password" required minLength={8} type="password" placeholder="Password (min. 8)" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} className={inputCls} />
          <select data-testid="new-user-role" value={f.role} onChange={(e) => setF({ ...f, role: e.target.value })} className={inputCls}>
            <option value="collaboratore">Collaboratore</option><option value="titolare">Titolare</option>
          </select>
          <button data-testid="new-user-submit" className={`${btnPrimary} sm:col-span-2`}>Crea utente</button>
        </form>
      </Panel>
    </div>
  );
}
